module.exports = __webpack_public_path__ + "static/img/lunboImg bg003.ff17b440.jpg";